// extracted by mini-css-extract-plugin
var _1 = "AvatarStack-module__allowItemOverflow--cEG4K";
var _2 = "AvatarStack-module__animateUploadProgressBarWidth--fu1bK";
var _3 = "AvatarStack-module__animatedBackground--HM0ct";
var _4 = "AvatarStack-module__buttonCount--jYj5r";
var _5 = "AvatarStack-module__circle--L2mfB";
var _6 = "AvatarStack-module__container--zMgYa";
var _7 = "AvatarStack-module__count--YxjYK";
var _8 = "AvatarStack-module__countContent--PZ9Z0";
var _9 = "AvatarStack-module__countWrapper--SPqCl";
var _a = "AvatarStack-module__item--f_QBl";
var _b = "AvatarStack-module__noWrap--YEE2R";
var _c = "AvatarStack-module__plus--WdQUn";
var _d = "AvatarStack-module__smallPill--BOPKJ";
var _e = "AvatarStack-module__tight--T2rND";
export { _1 as "allowItemOverflow", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "buttonCount", _5 as "circle", _6 as "container", _7 as "count", _8 as "countContent", _9 as "countWrapper", _a as "item", _b as "noWrap", _c as "plus", _d as "smallPill", _e as "tight" }
